import React, { useState } from 'react';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { Item } from './Item';
import { useActivityLogContext } from '../ActivitiyLogContext';

const INITIAL_NUMBER_OF_LOGS = 3;
const ALL_LOGS_TO_SHOW = 15;

export default function List() {
  const {
    activities,
  } = useActivityLogContext();

  const [shouldShowMoreActivity, setShowMoreActivity] = useState(false);

  const handleShowMoreActivity = () => {
    setShowMoreActivity(!shouldShowMoreActivity);
  };

  const numberOfLogsToShow = (shouldShowMoreActivity) ? ALL_LOGS_TO_SHOW : INITIAL_NUMBER_OF_LOGS;

  return (
    <>
      <div data-component="List">
        {activities.map((element, index) => (
          <Item
            key={index}
            name={element.name}
            date={element.date}
            device={element.device}
            index={index}
            numberOfLogsToShow={numberOfLogsToShow}
          />
        ))}
      </div>
      <div className="sui-flex sui-justify-center">
        <Button
          variant="text"
          onClick={handleShowMoreActivity}
        >
          <Typography>
            {shouldShowMoreActivity ? 'Hide All Activity' : 'Show More Activity'}
          </Typography>
        </Button>
      </div>
    </>
  );
}

List.propTypes = {};

List.defaultProps = {};

List.displayName = 'AccountActivityList';
